module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-3-d11a15ec.jpg";